// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__Ec2Wv","alertIcon":"ConfirmModal_alertIcon__2DDBF"};